import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAvailabilityBaseComponent } from '../base/product-availability-base.component';
import { LoadingIndicatorComponent } from '../../../base/loading-indicator/loading-indicator.component';

@Component({
    selector: 'app-product-availability-icon',
    imports: [
        CommonModule,
        LoadingIndicatorComponent,
    ],
    templateUrl: './product-availability-icon.component.html',
    styleUrls: ['./product-availability-icon.component.scss']
})
export class ProductAvailabilityIconComponent extends ProductAvailabilityBaseComponent { }
